import { isObject } from '@rjsf/utils';
import dictionarystreet from '../data/addresses.json';


export const formatAddress = (date_obj, dictionary)=>{

    if(!date_obj) return '';

    const { district, street, building, corpus } = date_obj;

    if(!date_obj ) return "Не вказано";

    //return [disctrict, street, building, corpus].join(",");
    
    //JSON.stringify(dictionarystreet.disctricts.find(d=>d._id == disctrict));


    const fullAddr = [];


    if(district)  dictionary.district && dictionary.district[district] && dictionary.district[district]['name'] && fullAddr.push( dictionary.district[district]['name'] + " р-н" );
    if(street)  dictionary.street && dictionary.street[street] && dictionary.street[street]['name'] && fullAddr.push( dictionary.street[street]['name']);
    if(building)  dictionary.building && dictionary.building[building] && dictionary.building[building]['name'] && fullAddr.push( "буд. " + dictionary.building[building]['name']);
    if(corpus)  dictionary.corpus && dictionary.corpus[corpus] && dictionary.corpus[corpus]['name'] && fullAddr.push( dictionary.corpus[corpus]['name']);


    return fullAddr.join(", ");


};

export const createFullAddressObject = (date_obj, dictionary)=>{

    const outObj = {district:{id:"",name:""}, street:{id:"",name:""}, building:{id:"",name:""}, corpus:{id:"",name:""}};

    if(!date_obj) return outObj;

    const { district, street, building, corpus } = date_obj;

    if(!district || !street || !building ) return date_obj;

    outObj.district.id = district;
    outObj.district.name = dictionary.district[district] && dictionary.district[district]['name'] || '';
    
    outObj.street.id = street;
    outObj.street.name = dictionary.street[street] && dictionary.street[street]['name'] || '';

    outObj.building.id = building;
    outObj.building.name = dictionary.building[building] && dictionary.building[building]['name'] || '';

    outObj.corpus.id = corpus;
    outObj.corpus.name = dictionary.corpus && dictionary.corpus[corpus] && dictionary.corpus[corpus]['name'] || "";

    return outObj;

};

export const createAddressObj = (reqObj) => {


    const outObj = {
        district: '',
        street: '',
        building: '',
        corpus: ''
    };

    if(!reqObj) return outObj;

    const { district, street, building, corpus } = reqObj;

    outObj.district = district;
    outObj.street = street;
    outObj.building = building;
    outObj.corpus = corpus;

    return outObj;

}

export const createAddressObj_ = (reqObj) => {


    const outObj = {
        district: '',
        street: '',
        building: '',
        corpus: ''
    };

    if(!reqObj || typeof reqObj !== "object" || Object.keys(reqObj).length !==5 ) return outObj;

    const { district, street, building, corpus } = reqObj;

    outObj.district = district.id || '';
    outObj.street = street.id || '';
    outObj.building = building.id || '';
    outObj.corpus = corpus.id || '';

    return outObj;

}


export function createArrBuildAndCorpus(arr){

    if(!arr) return [];

    const buildings = {};

    for(const building of arr){
        const {id, name } = building;

        if(!name) continue;

        const { ofFirstLevel, ofSecondLevel, ofThirdLevel} = name;

        if(!buildings[ofFirstLevel.fullName]) buildings[ofFirstLevel.fullName] = { _id:id, name: ofFirstLevel.fullName, corpuses:[] };

        if(ofSecondLevel && ofSecondLevel.fullName) buildings[ofFirstLevel.fullName]['corpuses'].push({ _id:id, name: ofSecondLevel.fullName});

    }

    return Object.keys(buildings).map(bkey=>buildings[bkey]);

}